import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import i18next from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  Headline, neutralizeBack,
  appActions,
  Antragsunterlagen,
  PrevNextButton,
} from 'ion-lib';

const Abschluss = () => {
  const nachname = useSelector((state) => state.daten.vn.nachname);
  const dispatch = useDispatch();

  useEffect(() => {
    neutralizeBack();
  });

  const getAntragsDok = () => {
    dispatch(appActions.pdfRequest('holeDokumente', `Antragsdokumente_${nachname.value}.pdf`));
  };

  return (
    <>
      <Row>
        <Col className="spkpanel">
          <Headline>{i18next.t('abschluss.headline')}</Headline>
          <p>
            {i18next.t('abschluss.ersterAbsatz')}
          </p>
          <h4 className="mt-5">
            Wie geht es weiter?
          </h4>
          <p>
            Wir prüfen Ihren Antrag und setzen uns in Kürze mit Ihnen in Verbindung.
          </p>
          <p>
            Bitte beachten Sie, dass diese Bestätigung noch keine Annahme Ihres Antrags auf Abschluss eines Versicherungsvertrages darstellt.
          </p>
          <p>
            {i18next.t('abschluss.fragen')}
          </p>
          <br />
          <p>Freundliche Grüße</p>
          <p>
            {i18next.t('anschrift.gruss')}
          </p>
        </Col>

        <Col lg={7}>
          <Antragsunterlagen handleAntragDownload={getAntragsDok} />
        </Col>
      </Row>
      <PrevNextButton />
    </>
  );
};

export default Abschluss;
